const PROMOTIONS = '/produits-a-tester';
const PROMOTIONS_FAVORITES = '/produits-a-tester-favoris';
const PROMOTIONS_NEXT = '/next-promos';
const PROMOTION = '/produits-a-tester/:id';
const PROMOTION_NEXT = '/next-promos/:id';
const CARD_SELECT = '/selection-carte/:id';
const CARD_SELECT_RAW = '/selection-carte/';
const COUPONS = '/mes-coupons';
const NEXT_COUPONS = '/next-coupons';
const EVALUATIONS = '/recuperer-mes-credits';
const NEXT_EVALUATIONS = '/next-credits';
const PROFILE = '/mon-profil';
const PROFILE_STEPS = '/mon-profil-premiere-evaluation/:evaluation_id?/:url*';
const PROFILE_SUCCESS = '/mon-profil-complet/:evaluation_id?/:url*';
const NEXT_PROFILE_FIRST = '/next-profile-first/:evaluation_id?';
const NEXT_PROFILE_SUCCESS = '/next-profile-success/:evaluation_id?';
const ROUTER_POST = '/routerPost/:evaluation_id/:url*';
const ROUTER = '/router/:id';
const ROUTER_NEXT_PRE = '/pre-router/:uuid';
const ROUTER_NEXT_POST = '/post-router/:uuid';
const CALLBACK = '/callback/:code?';
const CALLBACK_MOCK = '/callbackMock/:code?';
const SHOP_SELECT = '/selection-magasin';
const POP_UP_PARAMETER = 'pop-up';
const FIRST_SHOP_KEY = 'shop-ok';
const ACCEPTED_CONDITIONS_KEY = 'welcome';
const REGISTER = '/inscription/:name?/:lastName?/:username?/:card?';
const HOW_IT_WORKS = '/comment-ca-marche';
const SHOPS_PARTICIPANTS = '/magasins-participants';
const LEGAL_CONDITION = '/article/mentions-legales';
const COOKIES_POLICY = '/politique-de-cookies';
const FAQ = '/questions-frequentes';
const CONFIDENTIAL_LEGAL = '/article/politique-de-confidentialite';
const START = '/commencer';
const LOGOUT = '/logout';
const PRODUCTS_LIST = '/produits';
const PRODUCT_DETAIL = '/produits/:ean';
const SHUFFLE = '/shuffle/:invitationId?';
const ADDITIONAL_CREDITS = '/mes-credits-additionnels';
const FORCE_ERROR = '/force-front-throw-error';
const UNSUB = '/desinscription';
const LANDING_PAGE = '/demenagement';
const LANDING_CAMPAIGN_PAGE = '/campaign/:keyCampaign';
const MOCK_LANDING_CAMPAIGN_PAGE = '/mock-campaign/:keyCampaign';
const EXTRA = '/extra/:url';
const EXTERNAL_SURVEY = '/enquete/:userId/:surveyId';
const EXTERNAL_SURVEY_LOGGED = '/enquete/:surveyId';
const STATIC_CONTENT_REMOTE = '/article/:alias';
const MOBILE_CLEAN = '/mobile/:alias';
const CONTACT = 'https://contact-monavislerendgratuit.atlassian.net/servicedesk/customer/portals';
const LOGIN_SELECT = '/login-select';
const PO30 = '/rating-and-review/:id/:ean';
const CONTEST_COMMUNITY = '/concours-communaute';

const AVOID_CHECK_URLS = [
  STATIC_CONTENT_REMOTE,
  LANDING_PAGE,
  LANDING_CAMPAIGN_PAGE,
  MOCK_LANDING_CAMPAIGN_PAGE,
  PRODUCTS_LIST,
  PRODUCT_DETAIL,
  SHOPS_PARTICIPANTS,
  LEGAL_CONDITION,
  COOKIES_POLICY,
  CONFIDENTIAL_LEGAL,
  FAQ,
  CALLBACK,
  CALLBACK_MOCK,
  REGISTER,
];
const STATIC_HEADER_ROUTES = [SHOP_SELECT];
const NEXT_ROUTES = [
  PROMOTIONS_NEXT,
  PROMOTION_NEXT,
  NEXT_COUPONS,
  NEXT_EVALUATIONS,
  NEXT_PROFILE_FIRST,
  NEXT_PROFILE_SUCCESS,
  ROUTER_NEXT_PRE,
  ROUTER_NEXT_POST,
];
export {
  PROMOTIONS,
  PROMOTIONS_FAVORITES,
  PROMOTIONS_NEXT,
  COUPONS,
  NEXT_COUPONS,
  EVALUATIONS,
  NEXT_EVALUATIONS,
  PROFILE,
  PROFILE_SUCCESS,
  NEXT_PROFILE_FIRST,
  NEXT_PROFILE_SUCCESS,
  ROUTER,
  ROUTER_POST,
  ROUTER_NEXT_PRE,
  ROUTER_NEXT_POST,
  CALLBACK,
  CALLBACK_MOCK,
  SHOP_SELECT,
  POP_UP_PARAMETER,
  FIRST_SHOP_KEY,
  ACCEPTED_CONDITIONS_KEY,
  REGISTER,
  STATIC_HEADER_ROUTES,
  NEXT_ROUTES,
  HOW_IT_WORKS,
  SHOPS_PARTICIPANTS,
  LEGAL_CONDITION,
  COOKIES_POLICY,
  FAQ,
  CONFIDENTIAL_LEGAL,
  START,
  LOGOUT,
  PROMOTION,
  PROMOTION_NEXT,
  CARD_SELECT,
  CARD_SELECT_RAW,
  PRODUCTS_LIST,
  PRODUCT_DETAIL,
  SHUFFLE,
  ADDITIONAL_CREDITS,
  FORCE_ERROR,
  UNSUB,
  EXTRA,
  LANDING_PAGE,
  STATIC_CONTENT_REMOTE,
  MOBILE_CLEAN,
  EXTERNAL_SURVEY,
  EXTERNAL_SURVEY_LOGGED,
  CONTACT,
  LOGIN_SELECT,
  PROFILE_STEPS,
  LANDING_CAMPAIGN_PAGE,
  MOCK_LANDING_CAMPAIGN_PAGE,
  PO30,
  CONTEST_COMMUNITY,
  AVOID_CHECK_URLS,
};
